export const listViewUrl = "/";
export const formUrl = "/form";
export const loginUrl = "/login";
